import { useLastPathSegment } from 'shared/hooks'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { type CallingRoutesSteps } from 'pages/settings/pages/compliance/pages/calling/route/type'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useCallingStepsContext()

  return getProgressInfoTitle(useLastPathSegment() as CallingRoutesSteps)
}
